import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./components/AuthProvider";
import { ObservabilityProvider } from "./components/ObservabilityProvider";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { ProtectedRoute } from "./components/route-guards/ProtectedRoute";
import Layout from "./components/Layout";
import { publicRoutes, protectedRoutes } from "./config/routes.config";
import { queryClient } from "./lib/react-query";

const App = () => (
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ObservabilityProvider>
          <TooltipProvider>
            <Toaster />
            <Sonner />
            <BrowserRouter>
              <Routes>
                {/* Public routes */}
                {publicRoutes.map(({ path, element }) => (
                  <Route key={path} path={path} element={element} />
                ))}
                
                {/* Protected routes with Layout */}
                <Route 
                  path="/" 
                  element={
                    <ProtectedRoute>
                      <Layout />
                    </ProtectedRoute>
                  }
                >
                  {protectedRoutes.map(({ path, element, index }) => (
                    <Route 
                      key={index ? 'index' : path}
                      path={path}
                      index={index}
                      element={element}
                    />
                  ))}
                </Route>
              </Routes>
            </BrowserRouter>
          </TooltipProvider>
        </ObservabilityProvider>
      </AuthProvider>
    </QueryClientProvider>
  </ErrorBoundary>
);

export default App;
